import { RootState } from "../StoreHooks";

export const getPassengerFlowState = (state: RootState) => {
  const { paxFlow } = state.paxFlow || {};
  return paxFlow;
};
